import App from './App.vue'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/views/home-page.vue'
import About from './components/views/about-page.vue'
import Contact from './components/views/contact-page.vue'
import LohanaCommmunityHistory from './components/views/lohana-community-history.vue'
import SGLMHistory from './components/views/sglm-history.vue'
import SGLMCommittee from './components/views/sglm-committee.vue'
import SGLMTrustees from './components/views/sglm-trustees.vue'
import PastPresidents from './components/views/past-presidents.vue'
import PastVicePrsidents from './components/views/past-vice-presidents.vue'
import Varnisamiti from './components/views/sglm-varnisamiti.vue'
import SalahkarSamiti from './components/views/sglm-salahkarsamiti.vue'
import MahilaMandal from './components/views/mahila-mandal.vue'
import YuvakMandal from './components/views/yuvak-mandal.vue'
import OtherInstitutions from './components/views/other-institutions.vue'
import DonationsPage from './components/views/donations-page.vue'
import DownloadForms from './components/views/download-forms-page.vue'
import ConferenceHall  from './components/views/conference-hall.vue'
import BanquetHall from './components/views/banquet-hall.vue'
import RoomsOnRent from './components/views/rooms-on-rent.vue'
import AccountingReports from './components/views/accounting-reports.vue'
import EventsPage from './components/views/events-page.vue'
import DownloadForm from './components/views/download-form.vue'
import './assets/tailwind.css'
import GalleyPage from './components/views/galley-page.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { register } from 'swiper/element/bundle';
import axiosInstance from './utils/axiosInstance.js'

const routes = [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact },
    { path: '/about/history-of-lohana-community/', component: LohanaCommmunityHistory},
    { path: '/about/history-of-sglm/', component: SGLMHistory},
    { path: '/about/the-committee/', component: SGLMCommittee},
    { path: '/about/trustees/', component: SGLMTrustees},
    { path: '/about/past-presidents/', component: PastPresidents},
    { path: '/about/past-vice-presidents/', component: PastVicePrsidents},
    { path: '/about/salahkar-samiti/', component: SalahkarSamiti},
    { path: '/about/varnisamiti/', component: Varnisamiti},
    { path: '/mahila-mandal', component: MahilaMandal},
    { path: '/yuvak-mandal', component: YuvakMandal},
    { path: '/other-institutions', component: OtherInstitutions},
    { path: '/donations', component: DonationsPage},
    { path: '/download-forms', component: DownloadForms},
    { path: '/conference-hall', component: ConferenceHall},
    { path: '/banquet-hall', component: BanquetHall},
    { path: '/rooms-on-rent', component: RoomsOnRent},
    { path: '/accounts', component: AccountingReports},
    { path: '/events', component: EventsPage},
    { path: '/gallery', component: GalleyPage },
    {path: '/download-form', component: DownloadForm },
    { path: '/:pathMatch(.*)*', redirect: '/' },
    

]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

async function warmUpBackend() {
  try {
    // Replace '/api/health-check' with any lightweight backend endpoint
    await axiosInstance.get('/home-page');
    console.log('Backend warm-up call initiated or instance was already warm.');
  } catch (error) {
    // It's okay if this fails (e.g., cold start), the main app should still load.
    // You can log this for monitoring if desired.
    console.warn('Backend warm-up call failed:', error.message);
  }
}

// new Vue({
//     router,
//     render: h => h(App)
// }).mount('#app')

// Initiate the warm-up call when the app is created
warmUpBackend();
createApp(App).use(router).use(register).use(ElementPlus).mount('#app')